import React, { useEffect } from 'react';

import { getPlatform } from '../../utils/platformHelpers';
import {
  SLEEPIO_APP_STORE_URL,
  SLEEPIO_GOOGLE_PLAY_URL,
  SPARK_APP_STORE_URL,
  SPARK_GOOGLE_PLAY_URL,
  DAYLIGHT_APP_STORE_URL,
  DAYLIGHT_GOOGLE_PLAY_URL,
} from '../../utils/constants';

import { Platform, isSpark as isSparkHelper, isDaylight as isDaylightHelper } from '@/utils/productHelpers';

const AppStoreRedirector = (): React.ReactElement => {
  useEffect(() => {
    const platform = getPlatform();
    const qsProduct = new URLSearchParams(window.location?.search ?? '').get('product') ?? undefined;
    const pathProduct = (window.location?.pathname ?? '').match(
      /(spark(?:[-_.\s]direct|[-_.\s]wellness|[-_.\s]2\.0)?|daylight)/i,
    )?.[1];
    const product = qsProduct ?? pathProduct;
    const isSpark = isSparkHelper(product);
    const isDaylight = isDaylightHelper(product);

    let appStoreUrl = SLEEPIO_APP_STORE_URL;
    let googlePlayUrl = SLEEPIO_GOOGLE_PLAY_URL;

    if (isSpark) {
      appStoreUrl = SPARK_APP_STORE_URL;
      googlePlayUrl = SPARK_GOOGLE_PLAY_URL;
    } else if (isDaylight) {
      appStoreUrl = DAYLIGHT_APP_STORE_URL;
      googlePlayUrl = DAYLIGHT_GOOGLE_PLAY_URL;
    }

    if (platform === Platform.Android) {
      window.location.href = googlePlayUrl;
    }
    if (platform === Platform.iOS) {
      window.location.href = appStoreUrl;
    }
  }, []);

  return <h1>Redirecting...</h1>;
};

export default AppStoreRedirector;
